import type { ConceptDef } from '../types';

const bins = (id: string, name: string, groups: { label: string; items: string[] }[], description: string): ConceptDef => ({
  kind: 'sortBins',
  id,
  label: name,
  category: 'Sorting',
  description,
  config: { sequences: groups, itemsPerRound: 6, chipSpeech: true, errorless: 'off' },
});

export const binsHotCold = bins('bins-hot-cold', 'Sort Into Groups: Hot or Cold', [
  { label: '🔥 hot', items: ['☀️ sun', '🔥 fire', '🍲 soup', '☕ hot drink', '🌶️ chilli'] },
  { label: '🧊 cold', items: ['🧊 ice', '⛄ snowman', '🍦 ice cream', '❄️ snow', '🥶 cold face'] },
], 'Drag each card to hot or cold.');

export const binsLiving = bins('bins-living', 'Sort Into Groups: Living or Not Living', [
  { label: '🌱 living', items: ['🐶 dog', '🌳 tree', '🐦 bird', '🐟 fish', '🌻 flower', '👶 baby'] },
  { label: '🪨 not living', items: ['🚗 car', '🪑 chair', '⚽ ball', '☕ cup', '📚 book', '🪨 rock'] },
], 'Drag each card to living or not living.');

export const binsLandSeaSky = bins('bins-land-sea-sky', 'Sort Into Groups: Land, Sea or Sky', [
  { label: '🏞️ land', items: ['🚗 car', '🐴 horse', '🚂 train', '🐘 elephant'] },
  { label: '🌊 sea', items: ['⛵ boat', '🐟 fish', '🐋 whale', '🐙 octopus'] },
  { label: '☁️ sky', items: ['✈️ plane', '🐦 bird', '🚁 helicopter', '🎈 balloon'] },
], 'Drag each card to where it belongs: land, sea or sky.');

export const binsFoodClothesToys = bins('bins-food-clothes-toys', 'Sort Into Groups: Food, Clothes, Toys', [
  { label: '🍽️ food', items: ['🍎 apple', '🍞 bread', '🧀 cheese', '🍌 banana'] },
  { label: '👕 clothes', items: ['🧦 socks', '🧢 hat', '🧥 coat', '👖 trousers'] },
  { label: '🧸 toys', items: ['⚽ ball', '🧸 teddy', '🪀 yo-yo', '🪁 kite'] },
], 'Drag each card to food, clothes or toys.');

export const binsBigSmall = bins('bins-big-small', 'Sort Into Groups: Big or Small', [
  { label: '🐘 big', items: ['🐘 elephant', '🚌 bus', '🏠 house', '🐋 whale', '🌳 tree'] },
  { label: '🐭 small', items: ['🐭 mouse', '🐜 ant', '🔘 button', '🐞 ladybird', '🔑 key'] },
], 'Drag each card to big or small.');

export const binsHealthy = bins('bins-healthy', 'Sort Into Groups: Every Day or Sometimes Food', [
  { label: '🥦 every day', items: ['🍎 apple', '🥕 carrot', '💧 water', '🥦 broccoli', '🍌 banana'] },
  { label: '🍰 sometimes', items: ['🍰 cake', '🍬 sweets', '🍟 chips', '🍫 chocolate', '🍩 doughnut'] },
], 'Drag each card to every-day food or sometimes food.');

export const binsLettersNumbers = bins('bins-letters-numbers', 'Sort Into Groups: Letters or Numbers', [
  { label: '🔤 letters', items: ['A', 'B', 'M', 'T', 'S', 'R'] },
  { label: '🔢 numbers', items: ['3', '7', '1', '9', '5', '2'] },
], 'Drag each card to letters or numbers.');

export const binsColours = bins('bins-colours', 'Sort Into Groups: Red, Blue, Yellow', [
  { label: '🟥 red', items: ['🍎 apple', '🍓 strawberry', '🚒 fire engine', '🌹 rose'] },
  { label: '🟦 blue', items: ['🫐 blueberries', '👖 jeans', '🐳 whale', '💧 water'] },
  { label: '🟨 yellow', items: ['🍌 banana', '🌞 sun', '🐥 chick', '🧀 cheese'] },
], 'Drag each card to its colour.');
